export default __webpack_public_path__ + "navigation-examples-custom-voice-controller-thumbnail-480-555cceca2abb9a57c0d950903b56184b.webp";